module.exports = __webpack_public_path__ + "static/media/Desktop_Summary_17.20bbbb0f.png";